import { render, staticRenderFns } from "./JuniorObedienceScores.vue?vue&type=template&id=52a41c9d"
import script from "./JuniorObedienceScores.vue?vue&type=script&lang=ts"
export * from "./JuniorObedienceScores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports